import React, { createContext, useContext, useEffect, useMemo, useState, useCallback } from 'react';
import { api } from '../lib/api';

const CatalogContext = createContext(null);

export function CatalogProvider({ children }) {
  const [data, setData] = useState({ movies: [], shows: [], podcasts: [], live: [], genres: [], languages: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    try {
      const r = await api.get('/catalog');
      setData(r.data);
      setError(null);
    } catch (e) {
      setError(e?.message || 'Failed to load catalog');
    } finally {
      setLoading(false);
    }
  }, []);
  useEffect(() => { load(); }, [load]);

  const value = useMemo(() => {
    const allContent = [...data.movies, ...data.shows, ...data.podcasts];
    const index = new Map([...allContent, ...data.live].map((c) => [c.id, c]));
    const byId = (id) => index.get(id);
    return {
      movies: data.movies, shows: data.shows, podcasts: data.podcasts, liveStreams: data.live,
      GENRES: data.genres, languages: data.languages, allContent, byId,
      pick: (...ids) => ids.map(byId).filter(Boolean),
      loading, error, reload: load,
    };
  }, [data, loading, error, load]);

  return <CatalogContext.Provider value={value}>{children}</CatalogContext.Provider>;
}

export const useCatalog = () => useContext(CatalogContext);
